import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import getOrderDetailDms from '../../modules/order/application/getOrderDetailDms';
import createApiOrderRepository from '../../modules/order/infrastructure/apiOrderRepository';

const repository = createApiOrderRepository();

export default {
  namespaced: true,

  state: {
    taxPercentage: 0,
  },

  getters: {
    getTaxPercentage(state) {
      return state.taxPercentage;
    },
  },

  mutations: {
    SET_TAX_PERCENTAGE(state, payload) {
      Vue.set(state, 'taxPercentage', payload);
    },
  },

  actions: {
    // TODO: Find a way to omit this endpoint call,
    // since it's called only to retrieve the tax percentage.
    async getOrderDetailDms({ commit }) {
      try {
        const orders = Vue.prototype.$session.get('orders');
        if (orders.length > 0) {
          const ONE_HUNDRED_PERCENTAGE = 100;
          const params = {
            orderId: orders[orders.length - 1].orderIdDMS,
            transactionId: uuidv4(),
            dealerId: +Vue.prototype.$session.get('dealerId'),
          };
          const orderDMS = await getOrderDetailDms(repository, params);

          const taxePercentage = orderDMS.taxTypePercentage / ONE_HUNDRED_PERCENTAGE;
          commit('SET_TAX_PERCENTAGE', taxePercentage);
        }
      } catch (err) {
        throw new Error(err);
      }
    },
  },
};
